// extracted by mini-css-extract-plugin
export default {"p_content":"_21eae7eeac"};